exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header .close{display:none}table{table-layout:fixed;word-wrap:break-word}#vista{height:10px}textarea{resize:none}#caracte_01{white-space:pre-wrap;overflow:hidden}", ""]);

// exports
